@if (isAnySelected) {
  <div class="chip-container">
    @for (option of getSelectedOptions(); track option) {
      <div class="chip me-2" [class.commodity-chip]="isCommodity">
        <span class="me-1">{{ option?.chipValue || option?.value }}</span>
        <div class="close-button" (click)="onRemoveOptions($event, option)">
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.77246 9.47699C9.87813 9.58266 9.9375 9.72599 9.9375 9.87543C9.9375 10.0249 9.87813 10.1682 9.77246 10.2739C9.66679 10.3795 9.52347 10.4389 9.37402 10.4389C9.22458 10.4389 9.08126 10.3795 8.97558 10.2739L5.99949 7.29684L3.02246 10.2729C2.91679 10.3786 2.77347 10.438 2.62402 10.438C2.47458 10.438 2.33126 10.3786 2.22559 10.2729C2.11991 10.1673 2.06055 10.0239 2.06055 9.87449C2.06055 9.72505 2.11991 9.58173 2.22559 9.47605L5.20262 6.49996L2.22652 3.52293C2.12085 3.41726 2.06148 3.27393 2.06148 3.12449C2.06148 2.97505 2.12085 2.83173 2.22652 2.72605C2.33219 2.62038 2.47552 2.56102 2.62496 2.56102C2.7744 2.56102 2.91773 2.62038 3.0234 2.72605L5.99949 5.70309L8.97652 2.72558C9.08219 2.61991 9.22552 2.56055 9.37496 2.56055C9.5244 2.56055 9.66772 2.61991 9.7734 2.72558C9.87907 2.83126 9.93844 2.97458 9.93844 3.12402C9.93844 3.27347 9.87907 3.41679 9.7734 3.52246L6.79637 6.49996L9.77246 9.47699Z"
              fill="#1F1F1F"
            />
          </svg>
        </div>
      </div>
    }
  </div>
}
